export const validateShareExperienceForm = (formData) => {
  const errors = {};

  // Full Name validation
  if (!formData.fullName || formData.fullName.trim() === '') {
    errors.fullName = 'Full name is required';
  } else if (formData.fullName.trim().length < 2) {
    errors.fullName = 'Full name must be at least 2 characters';
  } else if (formData.fullName.trim().length > 50) {
    errors.fullName = 'Full name must be less than 50 characters';
  }

  // Email validation
  if (!formData.email || formData.email.trim() === '') {
    errors.email = 'Email is required';
  } else {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      errors.email = 'Please enter a valid email address';
    }
  }

  // Message validation
  if (!formData.message || formData.message.trim() === '') {
    errors.message = 'Message is required';
  } else if (formData.message.trim().length < 10) {
    errors.message = 'Message must be at least 10 characters';
  } else if (formData.message.trim().length > 1000) {
    errors.message = 'Message must be less than 1000 characters';
  }

  // Images validation (optional but if provided, validate)
  if (formData.images && formData.images.length > 0) {
    const maxFileSize = 5 * 1024 * 1024; // 5MB
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
    const maxFiles = 10;

    if (formData.images.length > maxFiles) {
      errors.images = `Maximum ${maxFiles} images allowed`;
    }

    formData.images.forEach((file, index) => {
      if (file.size > maxFileSize) {
        errors.images = `Image ${index + 1} is too large. Maximum size is 5MB`;
      }
      if (!allowedTypes.includes(file.type)) {
        errors.images = `Image ${index + 1} must be a JPEG, PNG, or WebP file`;
      }
    });
  }

  return errors;
};
